import type { JSX } from 'react'

/**
 * One two-state switch: a painted track with a round knob that slides, and the
 * label beside it. `role="switch"` + `aria-checked` make it a switch to a
 * screen reader and to the preview's own inspector; the 44px hit area is the
 * element AROUND the pill (unpainted), never the pill grown to 44px — padding
 * is painted with the background, and a 44×44 pill is no longer a switch.
 *
 * The heading row's toggles and the phone bar's toggles are the same control:
 * one component, two placements (gutter.css moves the label below the track in
 * the bar, where there is no room beside it).
 */
export function ProvenanceToggle({
  id,
  label,
  checked,
  onChange,
  className,
}: {
  /** `data-mol-id`, so the preview and the e2e specs can target it. */
  id: string
  label: string
  checked: boolean
  onChange: (next: boolean) => void
  className?: string
}): JSX.Element {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      data-mol-id={id}
      onClick={() => onChange(!checked)}
      className={['mol-switch', className].filter(Boolean).join(' ')}
    >
      <span className="mol-switch-track" aria-hidden="true">
        <span className="mol-switch-knob" />
      </span>
      <span className="mol-switch-label">{label}</span>
    </button>
  )
}
